import styled from "styled-components";

export const RotateWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;
export default RotateWrapper;